import React from 'react';

import { cssMap } from '@atlaskit/css';
import { Anchor, Box, Inline } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	labelChip: {
		backgroundColor: token('color.background.neutral'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		borderRadius: token('radius.small'),
		paddingBlock: token('space.025'),
		paddingInline: token('space.050'),
		font: token('font.body.small'),
	},
	labelLink: {
		textDecoration: 'none',
	},
});

interface LabelListProps {
	labels: Array<{
		name: string;
	}>;
	spaceKey?: string;
	limitLabelLinksToSpace: boolean;
}

export const LabelList = function LabelList({
	labels,
	spaceKey,
	limitLabelLinksToSpace,
}: LabelListProps): React.JSX.Element {
	return (
		<Inline space="space.075" shouldWrap testId="content-by-label-labels">
			{labels.map((label) => {
				const labelUrl =
					limitLabelLinksToSpace && spaceKey
						? `/wiki/label/${spaceKey}/${label.name}`
						: `/wiki/label/${label.name}`;

				return (
					<Anchor
						key={label.name}
						href={labelUrl}
						testId={`label-${label.name}`}
						xcss={styles.labelLink}
					>
						<Box xcss={styles.labelChip}>{label.name}</Box>
					</Anchor>
				);
			})}
		</Inline>
	);
};
